export default __webpack_public_path__ + "static/media/downArrow.786e0bf1.svg";